import { styled } from 'styled-components';

export const SocialNovSvg = styled.svg`
 
fill: #F3F3F3;

&:hover {
    fill: white;
  }
`;